import { render, staticRenderFns } from "./Stage3.vue?vue&type=template&id=ba2f393e&scoped=true&"
import script from "./Stage3.vue?vue&type=script&lang=js&"
export * from "./Stage3.vue?vue&type=script&lang=js&"
import style0 from "./Stage3.vue?vue&type=style&index=0&id=ba2f393e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2f393e",
  null
  
)

export default component.exports